module.exports = __webpack_public_path__ + "img/20231215150724607ll0.5b16ba62.jpg";